import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyForImpact() {
  return <section data-section-id="234266" id="emergency-support" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="relative overflow-hidden rounded-lg bg-white p-10 md:p-16 lg:p-24 text-center shadow-2xl shadow-black/10 border-[12px] border-primary">
          
          {}
          <div className="absolute inset-0 bg-primary/5 mix-blend-overlay pointer-events-none" />
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjMTAyYTE4IiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-30 pointer-events-none" />

          <div className="relative z-20 max-w-4xl mx-auto flex flex-col items-center">
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-8 leading-tight tracking-tighter uppercase">
              Stuck on the road? We offer 24/7 towing to our shop.
            </h2>
            
            <p className="text-primary/80 text-lg md:text-xl mb-10 max-w-2xl font-default">
              Dott's Garage has been Albany's trusted roadside partner for over 100 years. Our heavy-duty fleet is ready to bring you home safely.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-chart-2 text-white hover:bg-chart-2/90 w-full sm:w-auto rounded-md font-bold text-xl h-16 px-10 shadow-lg shadow-chart-2/20 transition-transform hover:scale-105 animate-pulse">
                <Link to="#">Call (518) 459-3404<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-6" aria-hidden="true" data-ast-id="f:/src/pages/OurExpertise/sections/ReadyForImpact.tsx|sig:mp21ip" data-ast-start="2250" data-ast-end="2288"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
              
              <Button asChild size="lg" variant="outline" className="border-primary/20 text-primary hover:bg-primary/5 hover:text-primary w-full sm:w-auto rounded-md font-semibold text-base h-16 px-8 backdrop-blur-sm transition-colors">
                <Link to="/OurExpertisePage">
                  View Services
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}